import * as TK from 'pages/SignUpPage/translations/constants';
import { Translations } from 'translations/types';

export const signUpPageEnUsLocale: Translations = {
  [TK.SIGN_UP_PAGE_SIGN_IN_SUGGESTION]: 'Already have an account?',
  [TK.SIGN_UP_PAGE_SIGN_IN_LINK]: 'Login',
};
